import { render, staticRenderFns } from "./InflammationPage.vue?vue&type=template&id=85505880&scoped=true&"
import script from "./InflammationPage.vue?vue&type=script&lang=js&"
export * from "./InflammationPage.vue?vue&type=script&lang=js&"
import style0 from "./InflammationPage.vue?vue&type=style&index=0&id=85505880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85505880",
  null
  
)

export default component.exports